'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var $ = _interopDefault(require('jquery'));
var cookieHelper = _interopDefault(require('../helpers/cookie-helper.js'));

function CookiesNotice() {
  this.$el = $('.cookies-notice');
  this.$dismissBtn = this.$el.find('.js-dismiss-btn');
  this.cookieName = 'eu_cookies_acknowledged';

  this.setDismissedNoticeCookie = this.setDismissedNoticeCookie.bind(this);
  this._onDismissBtnClick = this._onDismissBtnClick.bind(this);

  if (!this.$el.length || this.hasDismissedNoticeCookie()) {
    return;
  }

  this.$dismissBtn.on('click', this._onDismissBtnClick);
  this.$el.addClass('js-is-active');
}

CookiesNotice.prototype.hasDismissedNoticeCookie = function () {
  return Boolean(cookieHelper.get(this.cookieName));
};

CookiesNotice.prototype.setDismissedNoticeCookie = function () {
  var oneYearFromNowDate = new Date(new Date().setYear(new Date().getFullYear() + 1));
  return cookieHelper.set(this.cookieName, 1, { expires: oneYearFromNowDate, path: '/' });
};

CookiesNotice.prototype._onDismissBtnClick = function () {
  this.setDismissedNoticeCookie();
  this.$el.removeClass('js-is-active');
};

module.exports = CookiesNotice;
